<htm-modal
	id="userModal"
	[modalTitle]="'frontpage.dashboard_tabs_personal_label' | translate"
	[titleExists]="true"
	[topAction]="true"
	[bottomAction]="true"
	size="medium"
>
	<ng-template>
		@if (userDataResource.isLoading()) {
			<loader />
		} @else {
			<alerts id="personalData" />
			@if (!userDataResource.error() && userDataResource.value()) {
				<h1>
					@if (authService.user.firstname && authService.user.lastname) {
						{{ authService.user.firstname }} {{ authService.user.lastname }}
					} @else if (
						!authService.user.firstname && !authService.user.lastname
					) {
						{{ authService.user.username }}
					}
				</h1>
				<table htm-table class="user-modal">
					@for (field of personalDataFields; track $index) {
						@let fieldData = userDataResource.value()?.[field.key];
						@let value = field.value ? field.value(fieldData) : fieldData;
						@if (value) {
							<tr>
								<th>{{ 'frontpage.' + field.key | translate | titlecase }}</th>
								<td>
									{{ value }}
								</td>
							</tr>
						}
					}
				</table>
			}
		}
	</ng-template>
</htm-modal>
